export default __webpack_public_path__ + "static/media/FilterWhite.21d12798.svg";